import React, { useEffect } from 'react';
import { useToast } from './toast';

interface FallbackProps {
    error?: Error;
}

const FallbackComponent: React.FC<FallbackProps> = ({ error }) => {
    const toast = useToast();

    useEffect(() => {
        toast.error({
            title: "Error",
            description: error?.message || "An unexpected error occurred",
            duration: 5000,
            status: "error",
            open: true
        });
        window.history.back();
        window.location.reload()
    }, []);

    return (
        <></>
    );
};

export default FallbackComponent;
